var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditOrderinfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.05175 12.8904H8.61361C8.88961 12.8904 9.11361 13.1144 9.11361 13.3904C9.11361 13.6664 8.88961 13.8904 8.61361 13.8904H6.49093C6.21493 13.8904 5.99093 13.6664 5.99093 13.3904C5.99093 13.1144 6.21493 12.8904 6.49093 12.8904H7.05175V3.11043H6.49023C6.21423 3.11043 5.99023 2.88643 5.99023 2.61043C5.99023 2.33443 6.21423 2.11043 6.49023 2.11043H7.54261C7.54561 2.11038 7.54868 2.11035 7.55175 2.11035C7.55475 2.11035 7.55781 2.11038 7.56081 2.11043H8.61288C8.88888 2.11043 9.11288 2.33443 9.11288 2.61043C9.11288 2.88643 8.88888 3.11043 8.61288 3.11043H8.05175V12.8904Z",
    fill: "#1080FF",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.27812 12.0837H5.25745C5.53345 12.0837 5.75745 11.8597 5.75745 11.5837V4.41699C5.75745 4.14099 5.53345 3.91699 5.25745 3.91699H4.27812C2.85079 3.91699 1.68945 5.08033 1.68945 6.51033V9.49699C1.68945 10.9237 2.85079 12.0837 4.27812 12.0837Z",
    fill: "#1080FF",
    fillOpacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.65625 12.0837H12.0949C13.5262 12.0837 14.6903 10.9203 14.6903 9.49033V6.51033C14.6903 5.08033 13.5296 3.91699 12.1022 3.91699H9.65625C9.38025 3.91699 9.15625 4.14099 9.15625 4.41699V11.5837C9.15625 11.8597 9.38025 12.0837 9.65625 12.0837Z",
    fill: "#1080FF",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditOrderinfo);
export default __webpack_public_path__ + "static/media/Edit Order info.132c28c8ee9aec1f22783700de708b45.svg";
export { ForwardRef as ReactComponent };